module.exports = __webpack_public_path__ + "static/cta-moc-1-1-c0f3c05d1e4625a73238848d22210479.png";